<a [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" class="cx-product-image-container" tabindex="-1">
  <div class="custom-cart-image">
    <cx-media
      class="cx-product-image"
      [container]="product.images?.['PRIMARY']"
      format="product"
      [alt]="product.summary || product.name || ''"
      [class.no-pointer]="!product.name"
      >
    </cx-media>
  </div>
</a>
<div class="cx-product-code">
  {{ product.code }}
</div>

<div [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" class="cx-product-name">
  {{ product.name }}
</div>

<div class="cx-product-price-container">
  <div class="cx-product-price" [attr.aria-label]="'productDetails.productPrice' | cxTranslate">
    {{ product.price?.formattedValue }}
  </div>
</div>


<cx-add-to-cart class="cx-add-to-cart" *ngIf="product?.stock?.stockLevelStatus != 'outOfStock'; else disabledButton"></cx-add-to-cart>

<ng-template #disabledButton>
  <button
    type="submit"
    ng-reflect-ng-class="btn btn-primary btn-block"
    class="btn btn-primary btn-block no-pointer"
    [disabled]="true"
  >
    <span ng-reflect-ng-class="" aria-label="Agregar al carro"> Agregar al carro </span>
  </button>
</ng-template>